import { FC } from 'react';
import { Grid, Box, Button } from '@mui/material';
import { SCUIGeneralDrawerHeader } from '../../../../../atomic/molecules';
import { useTranslation } from 'react-i18next';

export const SCUIReturnDetailDrawerContent: FC<{
    product: any;
    onClose?: any;
}> = ({ product, onClose }) => {
    const { t } = useTranslation();
    const goToProduct = () => {
        window.open(
            'https://www.lcw.com/model/?modelId=' + product?.modelId + '&optionId=' + product?.optionId,
            '_blank',
            'noopener,noreferrer'
        );
    };
    return (
        <form>
            <div className="commentFilterContainer">
                <Grid container spacing={2}>
                    <SCUIGeneralDrawerHeader header={t('general.productDetail')} onClose={onClose} />
                    <Grid
                        size={{
                            md: 12,
                            xs: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <Box
                            component="img"
                            sx={{
                                maxHeight: { xs: 512, lg: 512 },
                                maxWidth: { xs: 512, lg: 512 },
                                borderRadius: 1,
                                width: '-webkit-fill-available',
                            }}
                            src={product.productImageUrl}
                            loading="lazy"
                        />
                    </Grid>
                    <Grid
                        size={{
                            md: 12,
                            xs: 12,
                            lg: 12,
                            xl: 12,
                        }}
                    >
                        <Button
                            variant="outlined"
                            style={{ fontSize: 20, maxWidth: '370px', minWidth: '370px' }}
                            size="large"
                            onClick={goToProduct}
                        >
                            {t('general.goToProduct')}
                        </Button>{' '}
                    </Grid>
                    <table style={{ width: '100%' }}>
                        <tbody>
                            <tr>
                                <td className="txtDetailForDrawerTitle">{t('searchService.barcode')}</td>
                                <td>{product.barcode}</td>
                            </tr>
                            <tr>
                                <td className="txtDetailForDrawerTitle">{t('searchService.specialColorCode')}</td>
                                <td>
                                    {product.ozelKod1} - {product.renkKod}
                                </td>
                            </tr>
                            <tr>
                                <td className="txtDetailForDrawerTitle">{t('general.productName')}</td>
                                <td>{product.productDescriptionOnWebSite}</td>
                            </tr>
                            <tr>
                                <td className="txtDetailForDrawerTitle">{t('general.quantity')}</td>
                                <td>{product.piece}</td>
                            </tr>
                            <tr>
                                <td className="txtDetailForDrawerTitle">{t('general.size')}</td>
                                <td>{product.size}</td>
                            </tr>
                            <tr>
                                <td className="txtDetailForDrawerTitle">{t('searchService.isPurchasable')}</td>
                                <td>{product.restockQuantity}</td>
                            </tr>
                            <tr>
                                <td className="txtDetailForDrawerTitle">{t('general.nonSellableProduct')}</td>
                                <td>{product.nonRestockQuantity}</td>
                            </tr>
                            <tr>
                                <td className="txtDetailForDrawerTitle">{t('general.rejectedProduct')}</td>
                                <td>{product.rejectedQuantity}</td>
                            </tr>
                            <tr>
                                <td className="txtDetailForDrawerTitle">{t('general.returnReason')}</td>
                                <td>{product.reasonDescription}</td>
                            </tr>
                        </tbody>
                    </table>
                </Grid>
            </div>
        </form>
    );
};
